import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OtherOverridesDeleteService {

  constructor(private http: HttpClient) { }

  /**
   * Delete single other override payment
   * Matches AngularJS: firOtherOverrideScreenFactory.deletePayment
   *   1. Start with GlobalService.globalParams
   *   2. Merge filterParams
   *   3. Merge paymentData
   *   4. Ensure required fields (tax_year, scenario, jcd_key, scenarioCode, is_issue_key_enabled)
   *   5. POST as FormData
   */
  deletePayment(
    baseUrl: string,
    paymentData: any,
    clobSettings: any[],
    ssoId: string,
    globalService: any = {},
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=mz28fw`;

    // 1. Start with globalParams (matching: params = _.merge({}, GlobalService.globalParams, params))
    let params: any = {};
    if (globalService?.globalParams) {
      Object.assign(params, globalService.globalParams);
    } else {
      Object.assign(params, globalService);
    }

    // 2. Merge filterParams (matching: params = _.merge({}, GlobalService.globalParams, filterParams))
    Object.assign(params, filterParams);

    // 3. Merge paymentData (matching: params = _.merge(params, paymentData, params))
    Object.assign(params, paymentData);

    // 4. Ensure required fields with fallback chains (matching isIssueIDEnabled pattern)
    params.tax_year = params.tax_year || filterParams?.tax_year || globalService?.tax_year || globalService?.globalParams?.tax_year || '';
    params.scenario = params.scenario || filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '';
    params.jcd_key = params.jcd_key || filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '';
    params.scenarioCode = params.scenarioCode || filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.globalParams?.scenarioCode || 'RAF';
    params.is_issue_key_enabled = params.is_issue_key_enabled || filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || 'N';

    // 5. Add required parameters
    params.filing_key = filterParams?.filing_key || params.filing_key || '';
    params.sso_id = ssoId;

    // 6. Build FormData and POST (matching other working Angular components)
    const formData = new FormData();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        formData.append(key, params[key].toString());
      }
    });

    return this.http.post<any>(url, formData, { withCredentials: true });
  }

  /**
   * Delete batch other override payment
   * Matches AngularJS: firOtherOverrideScreenFactory.deleteBatchPayment
   *   1. Start with GlobalService.globalParams
   *   2. Merge filterParams
   *   3. Merge paymentData
   *   4. Ensure required fields (tax_year, scenario, jcd_key, scenarioCode, is_issue_key_enabled)
   *   5. POST as FormData
   */
  deleteBatchPayment(
    baseUrl: string,
    paymentData: any,
    clobSettings: any[],
    ssoId: string,
    globalService: any = {},
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=46d5az`;

    // 1. Start with globalParams (matching: params = _.merge({}, GlobalService.globalParams, params))
    let params: any = {};
    if (globalService?.globalParams) {
      Object.assign(params, globalService.globalParams);
    } else {
      Object.assign(params, globalService);
    }

    // 2. Merge filterParams (matching: params = _.merge({}, GlobalService.globalParams, filterParams))
    Object.assign(params, filterParams);

    // 3. Merge paymentData (matching: params = _.merge(params, paymentData, params))
    Object.assign(params, paymentData);

    // 4. Ensure required fields with fallback chains (matching isIssueIDEnabled pattern)
    params.tax_year = params.tax_year || filterParams?.tax_year || globalService?.tax_year || globalService?.globalParams?.tax_year || '';
    params.scenario = params.scenario || filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || '';
    params.jcd_key = params.jcd_key || filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || '';
    params.scenarioCode = params.scenarioCode || filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.globalParams?.scenarioCode || 'RAF';
    params.is_issue_key_enabled = params.is_issue_key_enabled || filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || 'N';

    // 5. Add required parameters
    params.filing_key = filterParams?.filing_key || params.filing_key || '';
    params.sso_id = ssoId;

    // 6. Build FormData and POST (matching other working Angular components)
    const formData = new FormData();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        formData.append(key, params[key].toString());
      }
    });

    return this.http.post<any>(url, formData, { withCredentials: true });
  }
}
